// src/AuthContext.js
import React, { createContext, useState, useContext, useEffect } from "react";
import { AdminStore } from "./store";

const AuthContext = createContext();

export const AuthPassProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  return (
    <AuthContext.Provider value={{ isAuthenticated, setIsAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
};

export const usePassAuth = () => {
  return useContext(AuthContext);
};
